
export default function SolutionsSection() {
  const solutions = [
    {
      number: '01',
      title: 'Seamless Talent Integration',
      subtitle: 'ONBOARDING',
      problem: 'New providers and staff often spend their first week "waiting on IT," unable to access the EHR, or struggling with unconfigured hardware. This wastes thousands in salary and delays patient billing.',
      value: 'We treat Day One as a critical success factor. We ensure every new hire is fully equipped, credentialed, and productive the moment they sit down. Your technology becomes a recruitment and retention tool, reflecting the professionalism of your practice.',
    },
    {
      number: '02',
      title: 'Risk-Free Transitions',
      subtitle: 'OFFBOARDING',
      problem: 'When an employee leaves, "orphan accounts" or uncollected hardware create massive HIPAA vulnerabilities and financial leakage.',
      value: 'We provide a bulletproof exit process. We immediately revoke access to sensitive patient data, secure the hardware, and document the inventory. We protect the business from the departing employee, ensuring no data leaves the building and no hardware is lost to the "black hole" of turnover.',
    },
    {
      number: '03',
      title: 'Executive Visibility & Governance',
      subtitle: 'COMMUNICATION',
      problem: 'Leadership is often kept in the dark about IT risks until something breaks, or they receive vague reports that don\'t help them make business decisions.',
      value: 'We bridge the gap between the server room and the boardroom. Through regular Strategic Business Reviews, we provide upper management with clear, jargon-free insights into security posture, budget forecasting, and compliance health. You will never have to wonder if your data is safe; you will have the data to prove it.',
    },
  ];

  return (
    <section id="solutions" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            High-Level Solutions for the Healthcare Executive
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl">
            Moving beyond "fixing things" toward Process Excellence
          </p>
        </div>

        <div className="space-y-12">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col lg:flex-row gap-8 items-start">
                {/* Number Badge */}
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 bg-gradient-to-br from-[#e10708] to-[#c00607] rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-5xl font-bold text-white">{solution.number}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <div className="mb-6">
                    <p className="text-xs uppercase tracking-widest text-gray-500 font-bold mb-2">
                      {solution.subtitle}
                    </p>
                    <h3 className="text-3xl font-bold text-gray-900">{solution.title}</h3>
                  </div>

                  <div className="space-y-6">
                    <div className="border-l-4 border-red-400 pl-6">
                      <p className="text-xs uppercase tracking-wider text-gray-500 font-semibold mb-2">
                        THE PROBLEM
                      </p>
                      <p className="text-gray-700 leading-relaxed">{solution.problem}</p>
                    </div>

                    <div className="border-l-4 border-[#e10708] pl-6">
                      <p className="text-xs uppercase tracking-wider text-[#e10708] font-semibold mb-2">
                        THE VALUE
                      </p>
                      <p className="text-gray-900 leading-relaxed font-medium">
                        {solution.value}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
